export default __webpack_public_path__ + "static/media/sortable-list.2ed2fd9a.gif";